module.exports = __webpack_public_path__ + "static/media/detailed_view.ce331150.gif";